import type { ClientInfoFromBackend } from './types';

import { URL } from '../../../constants';
import type { ServiceConfig } from '../../../utils/create-http-api-service';
import { defaultRequestService } from '../../../utils/default-request-service';

export const getClientInfo = (config: ServiceConfig) => {
  type AdapterProps = { response: ClientInfoFromBackend };
  const requestConfig = {
    headers: {
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'Expires': 0,
    },
  };

  return defaultRequestService<AdapterProps>(
    URL.ACCOUNT_ENDPOINT,
    config.instance.get,
    {
      requestConfig,
    });
};
